export function addToArray(src, item) {
  return [...src, item];
}
